(() => {
  // app/scripts/common/component/cartRemove.js
  var customElementsName = "cart-remove-button";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", (e) => {
          const { target } = e;
          if (!target.closest("a"))
            return;
          const link = target.closest("a");
          e.preventDefault();
          this.closest("cart-component").change({ detail: { customElement: link } });
        });
      }
    }
  );

  // app/scripts/common/component/cartNote.js
  var CartNote = class extends cartForm {
    constructor() {
      super();
      const { debounceTime } = theme;
      const textarea = this.querySelector("[name=note]");
      if (!textarea)
        return;
      textarea.addEventListener("input", debounceTime((event) => {
        this.postCart("update", JSON.stringify({ note: event.target.value }));
      }, 1e3));
      textarea.addEventListener("input", () => {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      });
    }
  };
  var customElementsName2 = "cart-note";
  !window.customElements.get(customElementsName2) && window.customElements.define(customElementsName2, CartNote);

  // app/scripts/cart-component.js
  !customElements.get("cart-component") && customElements.define(
    "cart-component",
    class extends cartForm {
      constructor() {
        super();
      }
      connectedCallback() {
        const { debounceTime } = theme;
        const debounce = debounceTime((e) => this.change(e), 400);
        this.addEventListener("change", debounce.bind(this));
        this.onUpdate = this.onUpdate.bind(this);
        this.onOpen = this.open.bind(this);
        this.onClose = this.close.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.onMeasurementModalHandler = this.onMeasurementModalHandler.bind(this);
        window.addEventListener("drawer:open-cart", this.onOpen);
        document.addEventListener("cart:build", this.onRefresh);
        if (!Shopify.designMode)
          window.addEventListener("MeasurementModal:load", this.onMeasurementModalHandler);
        this.addEventListener(
          "click",
          (e) => {
            const { target: el } = e;
            if (el.closest('a[href*="showOptions"]')) {
              e.preventDefault();
              this.querySelector("#showOptions summary")?.click();
            }
          },
          { passive: false }
        );
        this.bindDrStackedDiscountsAppEvent();
        this.bindPopupNotiCloseEvent();
        this.bindCartIconEvent();
        document.body.classList.add("cart-loaded");
      }
      bindPopupNotiCloseEvent() {
        this.popupNotiEventHandler = this.popupNotiEventHandler.bind(this);
        document.addEventListener("popup:afterClose", this.popupNotiEventHandler);
      }
      popupNotiEventHandler(e) {
        const id = e.detail.id;
        if (!id || id != "cartNotiSuccessPopup")
          return;
        this.open();
      }
      bindDrStackedDiscountsAppEvent() {
        window.theme = window.theme || {};
        window.theme.refreshCart = () => {
          this.onRefresh();
        };
        let timeoutID = setTimeout(() => {
          window.discountOnCartProApp?.updateWidgets();
        }, 5e3);
        this.retryDocapp = 0;
        this.docappClone = (e) => {
          if (timeoutID) {
            clearTimeout(timeoutID);
            timeoutID = null;
          }
          const originalElement = this.querySelector(".docapp-cart-with-coupon-summary--summary");
          if (!originalElement)
            return;
          try {
            const clonedElement = originalElement.cloneNode(true);
            clonedElement.classList.forEach((cls) => {
              clonedElement.classList.replace(cls, cls + "-sartoro");
            });
            clonedElement.querySelectorAll("*").forEach((el) => {
              el.classList.forEach((cls) => {
                el.classList.replace(cls, cls + "-sartoro");
              });
            });
            this.querySelector(".js-custom-docapp-cart").innerHTML = clonedElement.outerHTML;
          } catch (error) {
            console.log("docappClone:error::", error);
            if (this.retryDocapp < 1) {
              window.discountOnCartProApp?.updateWidgets?.();
              this.retryDocapp = 1;
            } else {
              this.retryDocapp = 0;
            }
          }
        };
        document.body.addEventListener("docapp-widgets-updated", this.docappClone);
        this.docappUpdateAffirm = (e) => {
          if (!e || !e.cart)
            return;
          const totalPrice = e.estimatedTotal || e.cart.total_price;
          const affirmEl = this.querySelector(".affirm-as-low-as");
          if (affirmEl) {
            affirmEl.setAttribute("data-amount", totalPrice);
            if (typeof window.affirm?.ui?.refresh === "function") {
              window.affirm.ui.refresh();
            }
          }
        };
        document.body.addEventListener("docapp-discount-applied", this.docappUpdateAffirm);
        this.updateTotalPrice = (e) => {
          if (!e || !e.cart)
            return;
          const totalPrice = e.estimatedTotal || e.cart.total_price;
          const totalPriceElms = this.querySelectorAll(".cart-total-price");
          const currentTotalPrice = +totalPriceElms[0]?.getAttribute("data-value");
          if (totalPriceElms.length > 0 && totalPrice != currentTotalPrice) {
            if (parseInt(totalPriceElms[0].getAttribute("data-origin")) > parseInt(totalPriceElms[0].getAttribute("data-api-total-price"))) {
              if (e.cart.original_total_price > parseInt(totalPriceElms[0].getAttribute("data-api-total-price"))) {
                totalPriceElms.forEach((ele) => {
                  ele.set(totalPrice);
                });
              }
            } else {
              totalPriceElms.forEach((ele) => {
                ele.set(totalPrice);
              });
            }
          }
        };
        document.body.addEventListener("docapp-discount-applied", this.updateTotalPrice);
      }
      bindCartIconEvent() {
        const cartIcon = document.querySelector(".js-header-cart-icon");
        if (!cartIcon)
          return;
        cartIcon.addEventListener("click", (e) => {
          if (theme.settings.cartStyle == "drawer_desktop" && !window.matchMedia("(min-width: 750px)").matches)
            return;
          const popup = this.closest("popup-component");
          if (!popup)
            return;
          e.preventDefault();
          e.stopPropagation();
          popup.isOpen ? this.close() : this.open();
        });
      }
      disconnectedCallback() {
        window.removeEventListener("drawer:open-cart", this.onOpen);
        document.removeEventListener("cart:build", this.onRefresh);
        if (!Shopify.designMode)
          window.removeEventListener("MeasurementModal:load", this.onMeasurementModalHandler);
        document.body.removeEventListener("docapp-widgets-updated", this.docappClone);
        document.body.removeEventListener("docapp-discount-applied", this.docappUpdateAffirm);
        document.body.removeEventListener("docapp-discount-applied", this.updateTotalPrice);
        document.removeEventListener("popup:afterClose", this.popupNotiEventHandler);
      }
      onMeasurementModalHandler() {
        const measurementModal = document.querySelector("#MeasurementModal");
        if (!measurementModal || measurementModal.classList.contains("loaded"))
          return;
        const url = measurementModal.dataset.fetchUrl;
        fetch(url).then((e) => e.text()).then((e) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(e, "text/html");
          measurementModal.querySelector(".modal__centered-content").innerHTML = doc.querySelector("#main-content").innerHTML;
          measurementModal.classList.add("loaded");
        });
      }
      async loadCartData(sections, retry = 1, cssSelector, docappTotalPrice) {
        try {
          const [sectionRes, cartRes] = await Promise.all([
            fetch(
              `${location.pathname}?sections=${sections}${cssSelector == ".js-sb-cart-free-shipping" ? "&docapp_total_price=" + docappTotalPrice : ""}`
            ),
            fetch(`${theme.routes.cartUrl}.js`)
          ]);
          if (!sectionRes.ok || !cartRes.ok) {
            throw new Error(`Response error`);
          }
          const [data1, data2] = await Promise.all([sectionRes.json(), cartRes.json()]);
          return { data1, data2 };
        } catch (error) {
          console.error("LoadCartData error:", error);
          if (retry > 0) {
            return await loadCartData(sections, retry - 1, cssSelector, docappTotalPrice);
          }
          return null;
        }
      }
      async onRefresh(evt = {}) {
        const { detail } = evt;
        const redirectOrOpenDrawer = detail?.redirectOrOpenDrawer ? true : false;
        const cssSelector = detail?.cssSelector || "";
        const docappTotalPrice = detail?.docappTotalPrice;
        const section = theme.routes.pageType == "cart" ? this.getAttribute("data-section-id") : "cart-section";
        const effect = "default";
        const type = "refresh";
        this.sections.find((i) => i.key == "section").section = section;
        let sections = this.sections.map((i) => i.section);
        sections.push(section);
        sections = Array.from(new Set(sections));
        const data = await this.loadCartData(sections, 1, cssSelector, docappTotalPrice);
        if (!data) {
          this.notify("An error occurred while updating the cart. Please reload page.");
          return;
        }
        const { data1, data2 } = data;
        data2.sections = data1;
        this.update({ detail: { sections: data1, status: 200, cart: data2, effect, type, cssSelector } });
        if (redirectOrOpenDrawer) {
          this.onUpdate({
            detail: { sections: data1, status: 200, cart: data2, effect, type, redirectOrOpenDrawer }
          });
        }
      }
      /**
       * events to edit and delete a line item in the cart
       */
      change(event) {
        let target = event.target;
        let quantity = 0;
        if (event.detail) {
          target = event.detail.customElement;
        } else {
          quantity = +target.value;
        }
        let { line, sections: section, sections_url } = target.dataset;
        if (!line)
          return;
        this.sections.find((i) => i.key == "section").section = section;
        let sections = this.sections.map((i) => i.section);
        sections.push(section);
        sections = Array.from(new Set(sections));
        const body = {
          line: parseInt(line),
          quantity,
          sections,
          sections_url
        };
        this.style.pointerEvents = "none";
        this.postCart("change", JSON.stringify(body), (cart) => {
          this.style.pointerEvents = "auto";
          window.dispatchEvent(new CustomEvent("addOn:refresh", { detail: { cart } }));
        });
      }
      onUpdate(evt) {
        const {
          detail: { sections, status, cart, effect, type, redirectOrOpenDrawer }
        } = evt;
        if (!status || effect == "none")
          return;
        if (theme.routes.pageType == "cart") {
          !cart.item_count && location.reload();
        } else if (theme.settings.cartStyle == "drawer_desktop" && !window.matchMedia("(min-width: 750px)").matches) {
          window.location.href = theme.routes.cartUrl;
        } else {
          if (type != "add" && type != "refresh")
            return;
          if (redirectOrOpenDrawer || !document.querySelector("#addOnsDrawer") || type == "add") {
            this.open();
          }
        }
      }
      open() {
        this.closest("popup-component")?.open();
        window.dispatchEvent(new Event("MeasurementModal:load"));
      }
      close() {
        this.closest("popup-component")?.close();
        this.dispatchEvent(new Event("drawer:close-cart"));
      }
    }
  );
})();
